import { Dimensions } from 'react-native';

const { height, width } = Dimensions.get('window');

const lineHeight = height * 0.012;
const lineStyle = {
  height: lineHeight,
  borderRadius: 0,
};

const dimensions = {
  firstLine: '100%',
  secondLine: '100%',
  circle: width * 0.12,
};

const styles = {
  firstLine: { marginBottom: height * 0.01, ...lineStyle },
  secondLine: { marginBottom: height * 0.015, ...lineStyle },
};

export { dimensions, styles };
